var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-content',{attrs:{"code":"401","desc":"没有权限访问该内容,请联系管理人员添加权限!","src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }